import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = { class: "base-select__inner" }
const _hoisted_3 = { class: "base-select__content" }
const _hoisted_4 = {
  key: 0,
  class: "base-select__selected-option"
}
const _hoisted_5 = {
  key: 1,
  class: "base-select__placeholder"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "base-select__indicator" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "base-select__dropdown-background" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "base-select__list-item base-select__list-header"
}
const _hoisted_9 = {
  key: 1,
  class: "base-select__list-item base-select__list-empty"
}
const _hoisted_10 = { class: "base-select__option-content" }
const _hoisted_11 = ["aria-selected", "aria-disabled", "onClick"]
const _hoisted_12 = { class: "base-select__option-content" }
const _hoisted_13 = {
  key: 2,
  class: "base-select__list-item base-select__list-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "rootEl",
    class: _normalizeClass(["base-select", _ctx.rootNodeClasses]),
    role: "listbox",
    "aria-haspopup": "true",
    "aria-expanded": `${_ctx.open}`,
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.hasValue)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.selectedLabel), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.placeholder), 1))
      ]),
      _hoisted_6
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", {
        class: _normalizeClass(["base-select__dropdown base-select-dropdown", {
					'base-select-dropdown--is-open': _ctx.open,
					'base-select-dropdown--bottom': _ctx.bottomMode,
					'base-select-dropdown--is-small': _ctx.small,
				}]),
        style: _normalizeStyle(_ctx.dropdownStyle)
      }, [
        _hoisted_7,
        _createElementVNode("ul", {
          ref: "listEl",
          class: "base-select__list",
          tabindex: "-1",
          role: "listbox",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          (_ctx.hasListHeader)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _renderSlot(_ctx.$slots, "list-header")
              ]))
            : _createCommentVNode("", true),
          (_ctx.noOptions)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _renderSlot(_ctx.$slots, "list-empty", {}, () => [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.listEmpty), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (_ctx.displayOption(index))
                ? (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: _normalizeClass(["base-select__list-item base-select__option", _ctx.getOptionClasses(index)]),
                    role: "option",
                    "aria-selected": _ctx.isSelected(index),
                    "aria-disabled": _ctx.isDisabled(index),
                    onClick: ($event: any) => (_ctx.onOptionClicked(index))
                  }, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(option[_ctx.labelKey]), 1)
                  ], 10, _hoisted_11))
                : _createCommentVNode("", true)
            ], 64))
          }), 256)),
          (_ctx.hasListFooter)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _renderSlot(_ctx.$slots, "list-footer")
              ]))
            : _createCommentVNode("", true)
        ], 512)
      ], 6)
    ]))
  ], 10, _hoisted_1))
}